<template>
    <div class="menu-bar">
        <div v-for="(item, index) in listMenu" :key="index" class="menu-bar-item"
            :class="selectedItemId == item.id ? 'btn-active' : ''" @click="changeMenu(item.id)">
            <!-- 按钮类型0 -->
            <div v-if="item.type == 0" class="menu-bar-btn0">
                <span class="menu-bar-btn0-icon" :class="item.css"></span>
                <span class="menu-bar-btn0-title">{{ item.cnName }}</span>
            </div>
            <!-- 按钮类型1 -->
            <div v-if="item.type == 1" class="menu-bar-btn1">
                <span class="menu-bar-btn1-icon" :class="item.css"></span>
                <span class="menu-bar-btn1-title">{{ item.cnName }}</span>
            </div>
            <!-- 按钮类型2 -->
            <div v-if="item.type == 2" class="menu-bar-btn2">
                <span class="menu-bar-btn2-icon" :class="item.css"></span>
                <span class="menu-bar-btn2-title">{{ item.cnName }}</span>
                <!-- <span class="maps-count">{{ mapCount }}</span> -->
                <!-- <span class="maps-count-bg"></span> -->
            </div>
        </div>
    </div>
</template>

<script>

import { selectMenuByLevel } from '@/api/Common';
import { useRouter } from 'vue-router';

import { useMapStore } from '@/stores/mapStore'; // 引入 mapStore


export default {
    name: 'MenuBar',
    data() {
        return {
            selectedItemId: 0,
            listMenu: [],
            router: null,
            mapCount: 0,
            userInfo: null,
            mapStore: useMapStore()
        }
    },
    props: {
        level: Number
    },
    mounted() {
        this.router = useRouter();
        this.userInfo = this.mapStore.getUserInfo();
        if (!this.userInfo) {
            this.$router.push({ path: '/login' });
            return;
        }
        if (this.userInfo.admin == true) {
            this.listMenu = [{ "id": 1, "pid": 0, "cnName": "地图", "enName": "Map", "url": null, "perams": null, "type": 1, "css": "icon-map", "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 2, "pid": 1, "cnName": "我的地图", "enName": "My Map", "url": "/map/content", "perams": null, "type": 2, "css": null, "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 3, "pid": 1, "cnName": "地图设置", "enName": "Map Setting", "url": "/map/mapsetting", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 4, "pid": 0, "cnName": "团队", "enName": "Team", "url": null, "perams": null, "type": 1, "css": "icon-team", "icon": null, "level": 0, "orderNum": 2, "isShow": 1, "bak": null },
            // { "id": 5, "pid": 3, "cnName": "团队看板", "enName": "Team Signage", "url": "/map/teampanel", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 6, "pid": 3, "cnName": "团队设置", "enName": "Team Setting", "url": "/map/teamsetting", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 2, "isShow": 1, "bak": null },
            { "id": 7, "pid": 3, "cnName": "用户管理", "enName": "User List", "url": "/map/userlist", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 3, "isShow": 1, "bak": null }];
        } else {
            this.listMenu = [{ "id": 1, "pid": 0, "cnName": "地图", "enName": "Map", "url": null, "perams": null, "type": 1, "css": "icon-map", "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 2, "pid": 1, "cnName": "我的地图", "enName": "My Map", "url": "/map/content", "perams": null, "type": 2, "css": null, "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 4, "pid": 0, "cnName": "团队", "enName": "Team", "url": null, "perams": null, "type": 1, "css": "icon-team", "icon": null, "level": 0, "orderNum": 2, "isShow": 1, "bak": null },
            // { "id": 5, "pid": 3, "cnName": "团队看板", "enName": "Team Signage", "url": "/map/teampanel", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 1, "isShow": 1, "bak": null },
            { "id": 6, "pid": 3, "cnName": "团队设置", "enName": "Team Setting", "url": "/map/teamsetting", "perams": null, "type": 0, "css": null, "icon": null, "level": 0, "orderNum": 2, "isShow": 1, "bak": null }];
        }
        this.changeMenu(2);
    },
    // watch: {
    //     'mapStore.atlasList': {
    //         handler(newVal, oldVal) {
    //             this.mapCount = newVal.filter(item => item.delFlag === '0').length;
    //         },
    //         deep: true // 深度监听对象变化
    //     }
    // },
    methods: {
        changeMenu(id) {
            this.selectedItemId = id;
            for (const item of this.listMenu) {
                if (item.id == id) {
                    if (item.url != null) {
                        if (item.perams == null) {
                            this.router.replace({ path: item.url });
                        } else {
                            this.router.replace({ path: item.url, query: item.perams });
                        }
                    }
                    break;
                }
            }
        },
    }
}

</script>

<style scoped>
.menu-bar {
    color: #fff;
    margin-top: 12px;

}

.btn-active {
    background-color: #0095ff;
    color: #fff !important;
}

.menu-bar-item {
    color: #b2bcc5;
    padding: 10px 15px;
    cursor: pointer;
}

.menu-bar-btn1 {
    text-align: left;
    margin-left: 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.1;

}

.menu-bar-btn1-icon {
    width: 20px;
    height: 20px;
    background-position: 0 0;
    display: inline-block;

}

.menu-bar-btn1-title {
    vertical-align: super;
    margin-left: 6px;

}


.menu-bar-btn0 {
    text-align: left;
    margin-left: 12px;
    font-size: 14px;

    height: 20px;
    position: relative;
}

.menu-bar-btn0-icon {
    width: 20px;
    height: 20px;
    background-position: 0 0;
    display: inline-block;

}

.menu-bar-btn0-title {
    vertical-align: super;
    margin-left: 6px;
}


.menu-bar-btn2 {
    text-align: left;
    margin-left: 12px;
    font-size: 14px;

    height: 20px;
    position: relative;
}

.menu-bar-btn2-icon {
    width: 20px;
    height: 20px;
    background-position: 0 0;
    display: inline-block;
}

.menu-bar-btn2-title {
    vertical-align: super;
    margin-left: 6px;
}


.maps-count-bg {
    position: absolute;
    right: 7px;
    height: 14px;
    width: 30px;
    background-color: #304250;
    border-radius: 40px;
    top: 3px;
}

.maps-count {
    width: 30px;
    height: 14px;
    position: absolute;
    right: 7px;
    z-index: 10;
    text-align: center;
    line-height: 20px;
}
</style>